import { render, staticRenderFns } from "./ShopBetslip.vue?vue&type=template&id=3fa62323"
import script from "./ShopBetslip.vue?vue&type=script&lang=js"
export * from "./ShopBetslip.vue?vue&type=script&lang=js"
import style0 from "./ShopBetslip.vue?vue&type=style&index=0&id=3fa62323&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports